import { ThemeColors } from '~/themes/colors'

export interface FaxListViewColors {
  ScrollingList: {
    Item: {
      Subtitle: {
        Icon: {
          Inbound: ThemeColors
          Success: ThemeColors
          Failure: ThemeColors
        }
        FontColor: {
          Failed: ThemeColors
        }
      }
    }
  }
}

export const faxListViewColors: FaxListViewColors = {
  ScrollingList: {
    Item: {
      Subtitle: {
        Icon: {
          Inbound: {
            default: 'green.800',
          },
          Success: {
            default: 'blue.900',
          },
          Failure: {
            default: 'red.800',
          },
        },
        FontColor: {
          Failed: {
            default: 'red.800',
          },
        },
      },
    },
  },
}
